module.exports = __webpack_public_path__ + "img/close.d8323511.svg";